import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
export const StyledTypeAndSearchWithLink = styled.div`
  position: relative;
  display flex;
  flex-wrap: wrap;
  gap: ${toRem(16)};
  .search-container {
    width: 100%;
    @media ${baseVariables.mediaQuery.lg} {
      width: 70%;
    }
    position: relative;
    .clear-btn {
      position: absolute;
      top: 50%;
      right: ${toRem(1.28)};
      padding: ${toRem(5)} ${toRem(8)};
      transform: translateY(-50%);
      background-color: #ffff;
      &:hover {
        cursor: pointer;
      }
      &.isError {
        top:33%;
      }
    }
    .search_scroll {
      position: relative;
      background-color: ${baseVariables.color['base20']};
      ul {
        position: absolute;
        z-index: 1;
        padding: 0 ${toRem(12)};
        overflow-y: auto;
        max-height: ${toRem(280)};
        width: 100%;
        background-color: inherit;
        border: ${toRem(0.2)} solid black;
        border-top: none;
        border-radius: ${toRem(6)};
        li {
          list-style-type: none;
          padding: ${toRem(4)} 0;
          &:first-child,
          &:last-child {
            font-weight: 500;
            font-size: ${toRem(18)};
            font-family: proxima-nova, Helvetica, Arial, sans-serif;
            line-height: normal;
          }
        }

        li:not(:first-child):not(:last-child) {
          color: red;
          font-size: 0.875rem;
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
          &.highlighted-item {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }

  }
  .link-btn {
    @media screen and (max-width: 992px) {
      width: 90%;
      text-align: center;
      margin: 0 auto;
    }
  }
`;
